<template>
    <div style="display: flex; flex-direction: column;">
        <div style="position: relative;">
            <div @click="() => { $GlobalStore.closeLastModal() }" style="display: flex; align-items: center; gap: 4px; padding-left: 20px; padding-top: 26px; padding-bottom: 14px;">
                <img style="width: 14px; transform: rotate(180deg);" :src="require('@/assets/img/member_talk_x.png')" alt="">
                <div style="position: absolute; font-weight: 600; left: 50%; top: 58%;  transform: translate(-50%, -50%);">결제완료</div>
            </div>
        </div>
        <div style="flex: 1; background-color: #f5f5f5;">
            <div style="margin-top: 80px; text-align: center;">
                <div style="font-weight: 500;line-height: 24px;">결제완료</div>
                <div style="font-size: 24px;font-weight: 700;line-height: 34px; color: var(--color-main);">{{ payMethodObj.amt | comma }}원</div>
            </div>
            <div style="padding: 0 20px; margin-top: 16px;">
                <div style="padding: 16px; background-color: #fff; border-radius: 12px;">
                    <div style="display: flex; justify-content: space-between; font-size: 14px;font-weight: 500; padding-bottom: 12px; border-bottom: 1px solid #ededed;">
                        <div style="color: #808080;">결제수단</div>
                        <div>{{ payMethod }}</div> 
                    </div>
                    <div style="display: flex; justify-content: space-between; font-size: 14px;font-weight: 500; padding: 12px 0; border-bottom: 1px solid #ededed;">
                        <div style="color: #808080;">결제일자</div>
                        <div>{{ payMethod }}</div> 
                    </div>
                    <div style="display: flex; justify-content: space-between; font-size: 14px;font-weight: 500; padding-top: 12px;">
                        <div style="color: #808080;">결제정보</div>
                        <div>{{ payMethodObj.goods_name }}</div> 
                    </div>
                </div>
            </div>
        </div>
        <div style="height: 93px; margin-top: 12px; padding: 0 20px;">
            <div @click="completeAction" style="height: 48px; line-height: 48px; border-radius: 12px; color: #fff; font-weight: 700; font-size: 14px; background-color: #210F03; text-align: center;">{{ payMethodObj.goods_name }} 시작하기</div>
        </div>
    </div>
</template>

<script>
import { INNOPAY_PAY_METHOD } from "../../modules/InnoPay";
import { CARD_CODE_NAME } from "../../Constants";

export default {
    name: 'CompletePay',
    props: {
        payMethodObj: {
            type: Object,
            default: () => { }
        },
        completeAction: {
            type: Function,
            default: () => {}
        }
    },
    data() {
        return {
            payMethod: null
        }
    },
    created() {
        if (this.payMethodObj.pay_method === INNOPAY_PAY_METHOD.KAKAO) {
            this.payMethod = '간편결제'
        } else if (this.payMethodObj.pay_info === null) {
            this.payMethod = '일반결제'
        } else {
            this.payMethod = CARD_CODE_NAME[this.payMethodObj.pay_info.card_code] + ' (' + this.payMethodObj.pay_info.card_number + ')'
        }
    }
}
</script>

<style scoped></style>